import { Dispatch, SetStateAction, useState } from 'react';

type UseGeolocationPermissions = (allowGeolocation: boolean) => {
  isGeoPermissionDenied: boolean;
  setIsGeoPermissionDenied: Dispatch<SetStateAction<boolean>>;
  handleQueryPermissions: () => void;
};
export const useGeolocationPermissions: UseGeolocationPermissions = (
  allowGeolocation,
) => {
  const [isGeoPermissionDenied, setIsGeoPermissionDenied] =
    useState(!allowGeolocation);

  const handleQueryPermissions = () => {
    if (allowGeolocation === false) {
      return;
    }

    globalThis.navigator?.permissions
      ?.query({ name: 'geolocation' })
      .then((status) => {
        setIsGeoPermissionDenied(status.state === 'denied');
        return;
      })
      .catch(() => {
        setIsGeoPermissionDenied(true);
      });
  };

  return {
    isGeoPermissionDenied,
    setIsGeoPermissionDenied,
    handleQueryPermissions,
  };
};
